import React, { useCallback } from 'react'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { getSearchPath } from 'shared/util/search'
// @ts-ignore
import { Pill, TagText } from './sc'

type Props = {
    name: string
    analytics: {
        category: string
        action: string
    }
    onHover?: Function
    onClick?: Function
    isSticker: boolean
}
const Tag = ({ name, analytics, onHover, onClick, isSticker }: Props) => {
    const handleClick = useCallback(() => {
        const { action, category } = analytics
        googleAnalyticsEvent({
            category,
            action,
            label: name,
        })
        onClick?.()
    }, [onClick, name, analytics])

    const handleHover = useCallback(() => {
        onHover?.()
    }, [])

    const hasWordSticker = name.indexOf('sticker') === -1
    return (
        <Pill
            href={isSticker && hasWordSticker ? getSearchPath(name, true) : getSearchPath(name)}
            onClick={handleClick}
            onMouseEnter={handleHover}
        >
            <TagText>{`#${name}`}</TagText>
        </Pill>
    )
}

export default Tag
